import { Fragment, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { useFormData } from '../../../contexts/FormData';

import { useFormikContext } from 'formik';

import { Grid } from '@mui/material';

import { BasicFlex, ScrollableContainer } from '../../../utils/Common';

import { formatGenericDate } from '../../../utils/util';

import { useQuery } from '@tanstack/react-query';

import { getRequests, getRequestItems } from '../apiService';

import useSnackbarStore from '../../../store/snackbar';

import NoItems from '../../../utils/NoItems';


const Title = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${props => props.theme.colors.lightText};
  margin-bottom: 1rem;
`

const List = styled(BasicFlex)`
`;

const ListItem = styled(BasicFlex)`
  padding: 1.5rem 2rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${props => props.theme.colors.darkBg};
  };

  ${props => props.$disabled && css/* closed */`
    color: ${props.theme.colors.text.hint};
  `}
`;

let mockDate = new Date();

const mockRequests = [
  {
    request_id: 1,
    request_num: '1',
    vendor: 'Irene',
    item_qty: '1',
    fulfilled_qty: '1',
    total_qty: '1',
    status: 'unfulfilled',
    date_created: mockDate
  },
  {
    request_num: '2',
    vendor: 'Irene',
    item_qty: '1',
    fulfilled_qty: '1',
    total_qty: '1',
    status: 'unfulfilled',
    date_created: mockDate
  },
  {
    request_num: '3',
    vendor: 'Irene',
    item_qty: '1',
    fulfilled_qty: '0',
    total_qty: '1',
    status: 'unfulfilled',
    date_created: mockDate
  },
  {
    request_num: '4',
    vendor: 'Irene',
    item_qty: '1',
    fulfilled_qty: '0',
    total_qty: '1',
    status: 'unfulfilled',
    date_created: mockDate
  },
  {
    request_num: '5',
    vendor: 'Irene',
    item_qty: '1',
    fulfilled_qty: '0',
    total_qty: '1',
    status: 'unfulfilled',
    date_created: mockDate
  },
  {
    request_num: '6',
    vendor: 'Irene',
    item_qty: '1',
    fulfilled_qty: '1',
    total_qty: '1',
    status: 'unfulfilled',
    date_created: mockDate
  }
]

const RequestList = () => {
  const { formValues, setFormValues } = useFormData() || {};
  const { values } = useFormikContext() || {};

  const [requestId, setRequestId] = useState(null);

  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  const { data: requests = [] } = useQuery({
    queryKey: ['requests', values?.vendor_id],
    queryFn: () => getRequests(values?.vendor_id),
    enabled: !!values?.vendor_id
  });

  const { data: requestItems } = useQuery({
    queryKey: ['requests', 'request_items', requestId],
    queryFn: () => getRequestItems(requestId),
    enabled: !!requestId
  });

  useEffect(() => {
    if (requestItems) {
      setFormValues(obj => {
        return {
          ...obj,
          items: requestItems
        }
      });
    }
  }, [requestItems]);

  const attachedItems = formValues.wigs?.filter(item => item.request_id === requestId)?.length;
  console.log(attachedItems, "attachedItems");

  const selectRequest = (id) => {
    if (attachedItems) {
      showSnackbar('Please remove wigs before selecting another open request', 'error');
      return;
    }
    setRequestId(id);
  }

  return ( values?.vendor_id ?
    <Grid size={{xs: 12}}>
      <Title>Open Requests</Title>
      <ScrollableContainer>
        <List dir="column">
          {requests?.length ? requests.map((request, index) => (
            <ListItem key={index} onClick={() => selectRequest(request.request_id)} $disabled={request.request_id !== requestId && attachedItems}>
              <span>#{request.request_num}</span>
              <span>{request.vendor}</span>
              <span>{request.total_fulfilled} / {request.total_qty}</span>
              <span>{request.status}</span>
              <span>{formatGenericDate(request.date_created)}</span>
            </ListItem>
          )) : <NoItems title="No Open Requests Found" />}
        </List>
      </ScrollableContainer>
    </Grid>
 : null )
};

export default RequestList;